import { memo, ReactNode } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: SvgIconComponent;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'text' | 'outlined' | 'contained';
  };
  children?: ReactNode;
}

/**
 * Reusable empty state component for lists and collections
 */
export const EmptyState = memo<EmptyStateProps>(({
  title,
  description,
  icon: Icon,
  action,
  children,
}) => (
  <Paper sx={{ p: 4, textAlign: 'center' }}>
    {Icon && (
      <Box sx={{ mb: 2 }}>
        <Icon sx={{ fontSize: 48, color: 'text.secondary' }} />
      </Box>
    )}
    <Typography variant="h6" color="text.secondary" gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
    )}
    {action && (
      <Button
        variant={action.variant || 'contained'}
        onClick={action.onClick}
      >
        {action.label}
      </Button>
    )}
    {children}
  </Paper>
));

EmptyState.displayName = 'EmptyState';

export default EmptyState;
